"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var next_intl_1 = require("next-intl");
var navigation_1 = require("next/navigation");
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var Card = function (_a) {
    var promo = _a.promo, imageSrc = _a.imageSrc, _b = _a.isFullImage, isFullImage = _b === void 0 ? false : _b, _c = _a.showPromoTitle, showPromoTitle = _c === void 0 ? false : _c;
    var t = (0, next_intl_1.useTranslations)('translation');
    var router = (0, navigation_1.useRouter)();
    var generateUrlWithLang = (0, apps_shared_1.useGenerateUrlWithLang)();
    var clickParticipate = (0, react_1.useCallback)(function () {
        router.push(generateUrlWithLang("/promotions"));
    }, [generateUrlWithLang, router]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: styles_module_scss_1.default.cardTitle }, showPromoTitle ? promo.title : t('getYourDailyBonus')),
        isFullImage ? (react_1.default.createElement("div", { className: styles_module_scss_1.default.fullImageWrap },
            react_1.default.createElement("img", { className: styles_module_scss_1.default.fullImage, src: imageSrc, onClick: clickParticipate, alt: "promo" }))) : (react_1.default.createElement("div", { className: styles_module_scss_1.default.imageWrapper },
            imageSrc ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("img", { className: styles_module_scss_1.default.image, src: imageSrc, onClick: clickParticipate, alt: "promo" }))) : null,
            react_1.default.createElement("div", { className: styles_module_scss_1.default.hover, onClick: clickParticipate })))));
};
exports.default = Card;
